// @ts-strict-ignore
import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { isNullOrUndefined } from 'is-what';
import { uniqueId } from 'lodash-es';
import { InputBaseComponent } from '../input-base/input-base.component';

/**
 * @deprecated Use app-input-select
 */
@Component({
    selector: 'ui-input-select',
    templateUrl: './input-select.component.html',
    styleUrls: ['./input-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputSelectComponent<T> extends InputBaseComponent<T> {
  @Input() initialValue?: T;
  @Input() name: string = uniqueId('select');
  @Input() optionLabel: string;
  @Input() optionValue: string;
  @Input() options: T[];
  @Input() placeholder: string = '';
  @Input() readOnly: boolean = false;
  @Input() scrollHeight: string = '200px'; // PrimeNG default
  @Input() tabindex?: number;
  @Output() onFocus: EventEmitter<void> = new EventEmitter();

  @ContentChild(TemplateRef) optionTemplate;

  selectedItem: T;

  ngOnInit(): void {
    super.ngOnInit();

    if (this.initialValue) {
      this.writeValue(this.initialValue);
    }
  }

  getLabel(item: T) {
    if (this.optionLabel) {
      return item[this.optionLabel];
    }
    return item;
  }

  onBlur(event): void {
    setTimeout(() => {
      if (!event.target.value && !this.selectedItem) {
        this._emit();
      }
    }, 100); // Workaround to avoid triggering validator when valid slection is chosen.
  }
  onFocusInput(): void {
    this.onFocus.emit();
  }

  onValueChange(event: PointerEvent) {
    this._emit();
  }

  writeValue(value: any) {
    this.selectedItem = this.options.find((option) => {
      if (!isNullOrUndefined(this.optionValue) && !isNullOrUndefined(value)) {
        return option[this.optionValue] === value || option[this.optionValue] === value[this.optionValue];
      }
      return option === value;
    });
  }

  private _emit() {
    if (this.optionValue) {
      this.onChange(this.selectedItem?.[this.optionValue] ?? undefined);
    } else {
      this.onChange(this.selectedItem ?? undefined);
    }

    this.onTouched();
  }
}
